/**
 * 画像プレビューコンポーネント
 *
 * 添付画像のプレビュー表示と削除機能
 */

import { Box, Group, Text, ActionIcon } from "@mantine/core";
import { AttachedImage } from "../../services/assistantService";

interface ImagePreviewProps {
  images: AttachedImage[];
  onRemove: (index: number) => void;
}

/**
 * 画像プレビュー
 */
export function ImagePreview({ images, onRemove }: ImagePreviewProps) {
  if (images.length === 0) return null;

  return (
    <Group gap="xs" mb="xs">
      {images.map((img, index) => (
        <Box
          key={index}
          style={{
            position: "relative",
            width: 60,
            height: 60,
            borderRadius: 8,
            overflow: "hidden",
            border: "1px solid var(--mantine-color-dark-4)",
          }}
        >
          <img
            src={`data:${img.mimeType};base64,${img.data}`}
            alt={`添付画像 ${index + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          <ActionIcon
            variant="filled"
            color="dark"
            size="xs"
            radius="xl"
            onClick={() => onRemove(index)}
            style={{
              position: "absolute",
              top: 2,
              right: 2,
            }}
          >
            <Text size="xs">×</Text>
          </ActionIcon>
        </Box>
      ))}
    </Group>
  );
}
